module.exports = __webpack_public_path__ + "static/media/home3.d6a7b7b0.jpg";